
import React from "react";
import { Button } from "@/components/ui/button";
import { Download, RotateCw } from "lucide-react";

interface ActionButtonsProps {
  onProcessPayments: () => void;
  onExport: () => void;
  isProcessingPayments: boolean;
  isExporting: boolean;
}

export function ActionButtons({
  onProcessPayments,
  onExport,
  isProcessingPayments,
  isExporting
}: ActionButtonsProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full">
      <Button 
        onClick={onProcessPayments} 
        disabled={isProcessingPayments}
        className="flex-1"
        variant="destructive"
      >
        <RotateCw className="h-4 w-4 mr-2" />
        {isProcessingPayments ? "Processing..." : "Process Weekly Payments"}
      </Button>
      <Button 
        onClick={() => {
          console.log("Export button clicked by admin!");
          onExport();
        }} 
        disabled={isExporting} 
        variant="default"
        className="flex-1 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 text-lg"
        size="lg"
      >
        <Download className="h-5 w-5 mr-2" />
        {isExporting ? "Exporting..." : "Export Subscriptions (CSV)"}
      </Button>
    </div>
  );
}
